<template lang="pug">
v-tooltip(
  :disabled="!hasTooltip"
  bottom
  open-delay="200"
  max-width="400"
)
  template(#activator="{ on, attrs }")
    v-chip(
      :color="status.color"
      :small="small"
      :class="chipClass"
      :tabindex="hasTooltip ? 0 : null"
      v-bind="attrs"
      v-on="on"
    )
      span(:class="status.textColor || 'white--text'").b-600 {{ $t(status.text) }}

  div(v-if="status.hint") {{ $t(status.hint) }}
  div(v-else-if="textTooltip") {{ $t(status.text) }}
  slot(name="tooltip")
</template>

<script>
export default {
  name: 'StatusChip',
  props: {
    status: { type: Object, required: true },
    textTooltip: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    chipClass: { type: String, default: '' }
  },
  computed: {
    hasTooltip () {
      return this.textTooltip || Boolean(this.status.hint)
    }
  }
}
</script>
